import { render, staticRenderFns } from "./CheckinMembroTurma.vue?vue&type=template&id=664f4c34&scoped=true"
import script from "./CheckinMembroTurma.vue?vue&type=script&lang=js"
export * from "./CheckinMembroTurma.vue?vue&type=script&lang=js"
import style0 from "./CheckinMembroTurma.vue?vue&type=style&index=0&id=664f4c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f4c34",
  null
  
)

export default component.exports